/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VerifyPayJunctionRequest
 */
export interface VerifyPayJunctionRequest {
    /**
     * 
     * @type {string}
     * @memberof VerifyPayJunctionRequest
     */
    tokenId: string;
}

/**
 * Check if a given object implements the VerifyPayJunctionRequest interface.
 */
export function instanceOfVerifyPayJunctionRequest(value: object): value is VerifyPayJunctionRequest {
    if (!('tokenId' in value) || value['tokenId'] === undefined) return false;
    return true;
}

export function VerifyPayJunctionRequestFromJSON(json: any): VerifyPayJunctionRequest {
    return VerifyPayJunctionRequestFromJSONTyped(json, false);
}

export function VerifyPayJunctionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): VerifyPayJunctionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'tokenId': json['tokenId'],
    };
}

export function VerifyPayJunctionRequestToJSON(json: any): VerifyPayJunctionRequest {
    return VerifyPayJunctionRequestToJSONTyped(json, false);
}

export function VerifyPayJunctionRequestToJSONTyped(value?: VerifyPayJunctionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tokenId': value['tokenId'],
    };
}

